/**
 * wishlist.js — nút trái tim và số đếm "Yêu thích" (header + tab bar).
 *
 * Nút: button[data-wishlist-toggle] nằm trong [data-product][data-product-id]
 * (hoặc tự mang data-product-id). aria-pressed là nguồn sự thật cho CSS: true thì
 * tim Fill màu Error. Icon đổi giữa ph-bold và ph-fill vì Phosphor tách hai font —
 * không tô màu được phần ruột của bản Bold.
 *
 * WP: thay bằng plugin wishlist (YITH / TI) — giữ class .wish-btn để không phải sửa CSS.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    function store() {
        return window.WBStore;
    }

    function productId(button) {
        var holder = button.closest('[data-product]');
        return button.getAttribute('data-product-id') || (holder && holder.getAttribute('data-product-id'));
    }

    function paint(button, on) {
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.setAttribute('aria-label', on ? 'Bỏ khỏi yêu thích' : 'Thêm vào yêu thích');
        var icon = button.querySelector('i');
        if (icon) icon.className = (on ? 'ph-fill' : 'ph-bold') + ' ph-heart';
    }

    function renderButtons() {
        [].slice.call(document.querySelectorAll('[data-wishlist-toggle]')).forEach(function (button) {
            paint(button, store().wishlist.has(productId(button)));
        });
    }

    function renderCounts() {
        var count = store().wishlist.count();
        [].slice.call(document.querySelectorAll('[data-wishlist-count]')).forEach(function (el) {
            el.textContent = String(count);
            el.hidden = count === 0;
        });
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-wishlist-toggle]') : null;
        if (!button) return;
        event.preventDefault();

        var holder = button.closest('[data-product]');
        var snap = store().product(productId(button), holder || button);
        var added = store().wishlist.toggle(snap);

        if (window.WBToast && snap) {
            window.WBToast.show(added ? 'Đã lưu vào danh sách yêu thích' : 'Đã bỏ khỏi danh sách yêu thích', {
                icon: added ? 'ph-fill ph-heart' : '',
                action: added ? { label: 'Xem', href: 'wishlist.html' } : null
            });
        }
    });

    function init() {
        if (!store()) return;
        renderButtons();
        renderCounts();
        document.addEventListener('wb:wishlist', function () {
            renderButtons();
            renderCounts();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
